import { Dimensions, Image, Text, TouchableOpacity, View, Linking} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles';
import { FONTS, COLORS } from "../../constant";
const isSmallDevice = Dimensions.get('window').width < 767

const useStyles = CreateResponsiveStyle(
    {
        tabPlaystoreViewStyle: {
            display: "none",
            flexDirection: "row",
            marginTop: 30,
            alignItems: "center",
        },
        viewStyle1: {
            paddingTop: "10%",
            flexWrap: "wrap",
        },
        activateUserTextWidget: {
            flexDirection: 'row',
            alignItems: 'center'
        },
        tagBalLink:{paddingLeft:40,flexDirection: "row",alignItems: "center",display: "flex",},
        activateUserTextStyle: {
            fontFamily: "Inter",
            fontSize: 16,
            fontWeight: "normal",
            fontStyle: "normal",
            lineHeight: 12,
            letterSpacing: -0.2,
            textAlign: "left",
            color: "#54565b",
            textDecorationLine: "underline",
        },
        checkTagBalanceTextStyle: {
            fontFamily: "Inter",
            fontSize: 16,
            fontWeight: "normal",
            fontStyle: "normal",
            lineHeight: 12,
            letterSpacing: -0.2,
            textAlign: "left",
            color: "#54565b",
            textDecorationLine: "underline",
        },
        whatsupTextLink:{
            top:0,
            flexDirection:'row',
            alignItems:'center',
            left:10,
            display:'none'
        },
        whatsupText:{
            fontFamily: FONTS.Inter,
            fontSize: 15,
            color: COLORS.warmGrey1,
            paddingLeft:10
        }

    },

    {
        [DEVICE_SIZES.LG]: {

            viewStyle1: {
                paddingTop: "10%",
                flexWrap: "wrap",
            },
            activateUserTextStyle: {
                fontFamily: "Inter",
                fontSize: 18,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
            },
            checkTagBalanceTextStyle: {
                fontFamily: "Inter",
                fontSize: 18,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
            },

        },
        [DEVICE_SIZES.MD]: {
            tabPlaystoreViewStyle: {
                display: "flex",
            },
            whatsupTextLink:{
                display: "flex",
            },
            viewStyle1: {
                paddingTop: "10%",
                flexWrap: "wrap",
            },
            activateUserTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
            },
            checkTagBalanceTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
            },

        },
        [DEVICE_SIZES.SM]: {
            viewStyle1: {
                paddingTop: "10%",
                flexWrap: "wrap",
            },
            activateUserTextWidget: {
                display: 'none'
            },
            activateUserTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
            },
            checkTagBalanceTextStyle: {
                fontFamily: "Inter",
                fontSize: 12,
                fontWeight: "normal",
                fontStyle: "normal",
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
            },

        },
        [DEVICE_SIZES.XS]: {
            viewStyle1: {
                paddingTop: 10,
                flexWrap: "wrap",
            },
            activateUserTextWidget: {
                display: 'none'
            },
            activateUserTextStyle: {
                fontFamily: "Inter",
                fontSize: 14,
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
                paddingLeft: "2%",
            },
            checkTagBalanceTextStyle: {
                fontFamily: "Inter",
                fontSize: 14,
                lineHeight: 12,
                letterSpacing: -0.2,
                textAlign: "left",
                color: "#54565b",
                paddingTop: 0,
                paddingLeft: "2%",
            },
        },
    }
);

export default useStyles;